var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStoreBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 64,
    viewBox: "0 0 189 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 189,
    height: 64,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final UI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4566 -636.001C-4566 -774.072 -4454.07 -886 -4316 -886H22760C22898.1 -886 23010 -774.071 23010 -636V38139C23010 38277.1 22898.1 38389 22760 38389H-4316C-4454.07 38389 -4566 38277.1 -4566 38139V-636.001Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Sticky window",
    filter: "url(#filter0_d_2_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -376,
    y: -28,
    width: 850,
    height: 120,
    rx: 50,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -375.5,
    y: -27.5,
    width: 849,
    height: 119,
    rx: 49.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mobile app store badge"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.47639,
    y: 1.04548,
    width: 186.884,
    height: 61.909,
    rx: 8.42741,
    stroke: "#A6A6A6",
    strokeWidth: 1.29652
  }), /*#__PURE__*/React.createElement("g", {
    id: "App Store"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.674 31.4386V35.0587H126.422V37.4328H128.674V45.4994C128.674 48.2538 129.91 49.3556 133.021 49.3556C133.568 49.3556 134.089 49.29 134.544 49.2113V46.8635C134.154 46.9028 133.907 46.929 133.477 46.929C132.084 46.929 131.472 46.2732 131.472 44.778V37.4328H134.544V35.0587H131.472V31.4386H128.674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.47 49.5523C146.609 49.5523 149.147 46.7585 149.147 42.1284C149.147 37.5246 146.596 34.7177 142.47 34.7177C138.33 34.7177 135.779 37.5246 135.779 42.1284C135.779 46.7585 138.317 49.5523 142.47 49.5523ZM142.47 47.0471C140.035 47.0471 138.669 45.2501 138.669 42.1284C138.669 39.033 140.035 37.2229 142.47 37.2229C144.891 37.2229 146.271 39.033 146.271 42.1284C146.271 45.237 144.891 47.0471 142.47 47.0471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.319 49.2769H154.118V40.843C154.118 38.8362 155.615 37.4852 157.737 37.4852C158.231 37.4852 159.064 37.5771 159.299 37.6558V34.8751C158.999 34.7964 158.466 34.757 158.049 34.757C156.201 34.757 154.625 35.7801 154.222 37.1836H154.014V34.9931H151.319V49.2769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.248 37.118C168.317 37.118 169.671 38.5739 169.736 40.8168H162.577C162.733 38.587 164.178 37.118 166.248 37.118ZM169.723 45.4207C169.202 46.5356 168.044 47.152 166.352 47.152C164.113 47.152 162.668 45.5649 162.577 43.0597V42.9023H172.587V41.9186C172.587 37.4328 170.205 34.7177 166.261 34.7177C162.264 34.7177 159.726 37.6164 159.726 42.1809C159.726 46.7454 162.212 49.5523 166.274 49.5523C169.515 49.5523 171.78 47.9784 172.418 45.4207H169.723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.321 44.0021C110.536 47.5096 113.437 49.7527 117.754 49.7527C122.369 49.7527 125.256 47.4008 125.256 43.6487C125.256 40.6986 123.61 39.0672 119.616 38.1292L117.471 37.599C114.935 37.0008 113.909 36.1987 113.909 34.7985C113.909 33.0312 115.501 31.8756 117.889 31.8756C120.156 31.8756 121.721 33.004 122.004 34.8121H124.946C124.77 31.5085 121.883 29.1838 117.93 29.1838C113.68 29.1838 110.847 31.5085 110.847 35.0024C110.847 37.8845 112.452 39.5974 115.974 40.4267L118.483 41.0385C121.06 41.6502 122.193 42.5475 122.193 44.0429C122.193 45.783 120.412 47.0473 117.984 47.0473C115.38 47.0473 113.572 45.8646 113.316 44.0021H110.321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3293 34.757C79.4028 34.757 77.7366 35.7277 76.8775 37.3541H76.6692V34.9931H73.9747V54.025H76.7733V47.1127H76.9946C77.7366 48.6211 79.3377 49.513 81.3553 49.513C84.935 49.513 87.213 46.6667 87.213 42.1284C87.213 37.5902 84.935 34.757 81.3293 34.757ZM80.5352 46.9815C78.1922 46.9815 76.7213 45.119 76.7213 42.1416C76.7213 39.151 78.1922 37.2885 80.5483 37.2885C82.9174 37.2885 84.3362 39.1117 84.3362 42.1284C84.3362 45.1583 82.9174 46.9815 80.5352 46.9815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0059 34.757C95.0794 34.757 93.4132 35.7277 92.5541 37.3541H92.3458V34.9931H89.6513V54.025H92.45V47.1127H92.6713C93.4132 48.6211 95.0143 49.513 97.032 49.513C100.612 49.513 102.89 46.6667 102.89 42.1284C102.89 37.5902 100.612 34.757 97.0059 34.757ZM96.2119 46.9815C93.8688 46.9815 92.3979 45.119 92.3979 42.1416C92.3979 39.151 93.8688 37.2885 96.2249 37.2885C98.594 37.2885 100.013 39.1117 100.013 42.1284C100.013 45.1583 98.594 46.9815 96.2119 46.9815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9534 49.2769H72.1644L65.1352 29.6597H61.8837L54.8545 49.2769H57.9576L59.752 44.0701H67.1725L68.9534 49.2769ZM63.3543 33.2215H63.5837L66.4034 41.5143H60.521L63.3543 33.2215Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Download on the"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7344 14.8638V24.3273H60.1253C62.924 24.3273 64.5446 22.5894 64.5446 19.566C64.5446 16.5886 62.911 14.8638 60.1253 14.8638H56.7344ZM58.1923 16.2017H59.9626C61.9086 16.2017 63.0606 17.4478 63.0606 19.5857C63.0606 21.7565 61.9282 22.9894 59.9626 22.9894H58.1923V16.2017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.508 24.465C71.5777 24.465 72.8468 23.0681 72.8468 20.7531C72.8468 18.4512 71.5712 17.0477 69.508 17.0477C67.4383 17.0477 66.1626 18.4512 66.1626 20.7531C66.1626 23.0681 67.4318 24.465 69.508 24.465ZM69.508 23.2124C68.2909 23.2124 67.6075 22.3139 67.6075 20.7531C67.6075 19.2053 68.2909 18.3003 69.508 18.3003C70.7186 18.3003 71.4085 19.2053 71.4085 20.7531C71.4085 22.3074 70.7186 23.2124 69.508 23.2124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6549 17.1854H82.2556L80.9929 22.6353H80.8823L79.4243 17.1854H78.0836L76.6257 22.6353H76.5216L75.2524 17.1854H73.8335L75.7861 24.3273H77.2245L78.6824 19.0676H78.793L80.2574 24.3273H81.7088L83.6549 17.1854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2664 24.3273H86.6657V20.1497C86.6657 19.0348 87.3231 18.3397 88.3579 18.3397C89.3928 18.3397 89.8874 18.9102 89.8874 20.0579V24.3273H91.2868V19.7038C91.2868 18.0052 90.4146 17.0477 88.833 17.0477C87.7657 17.0477 87.0627 17.5265 86.7178 18.32H86.6136V17.1854H85.2664V24.3273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4905 24.3273H94.8899V14.3982H93.4905V24.3273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.153 24.465C102.222 24.465 103.492 23.0681 103.492 20.7531C103.492 18.4512 102.216 17.0477 100.153 17.0477C98.0829 17.0477 96.8073 18.4512 96.8073 20.7531C96.8073 23.0681 98.0764 24.465 100.153 24.465ZM100.153 23.2124C98.9356 23.2124 98.2522 22.3139 98.2522 20.7531C98.2522 19.2053 98.9356 18.3003 100.153 18.3003C101.363 18.3003 102.053 19.2053 102.053 20.7531C102.053 22.3074 101.363 23.2124 100.153 23.2124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.661 23.2583C106.899 23.2583 106.346 22.8845 106.346 22.2418C106.346 21.6122 106.789 21.2777 107.765 21.2122L109.496 21.1007V21.6975C109.496 22.5828 108.715 23.2583 107.661 23.2583ZM107.303 24.4453C108.234 24.4453 109.008 24.0387 109.431 23.3239H109.542V24.3273H110.889V19.448C110.889 17.9396 109.887 17.0477 108.11 17.0477C106.502 17.0477 105.357 17.8347 105.214 19.0611H106.567C106.724 18.5561 107.264 18.2675 108.045 18.2675C109.002 18.2675 109.496 18.6938 109.496 19.448V20.0645L107.576 20.176C105.891 20.2809 104.94 21.022 104.94 22.3074C104.94 23.6125 105.936 24.4453 107.303 24.4453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.638 24.4453C116.614 24.4453 117.441 23.9797 117.864 23.1993H117.974V24.3273H119.315V14.3982H117.916V18.32H117.812C117.428 17.533 116.607 17.0674 115.638 17.0674C113.848 17.0674 112.696 18.4971 112.696 20.7531C112.696 23.0157 113.835 24.4453 115.638 24.4453ZM116.035 18.3331C117.206 18.3331 117.942 19.2709 117.942 20.7596C117.942 22.2549 117.213 23.1796 116.035 23.1796C114.85 23.1796 114.141 22.268 114.141 20.7531C114.141 19.2513 114.857 18.3331 116.035 18.3331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.389 24.465C130.459 24.465 131.728 23.0681 131.728 20.7531C131.728 18.4512 130.452 17.0477 128.389 17.0477C126.319 17.0477 125.044 18.4512 125.044 20.7531C125.044 23.0681 126.313 24.465 128.389 24.465ZM128.389 23.2124C127.172 23.2124 126.489 22.3139 126.489 20.7531C126.489 19.2053 127.172 18.3003 128.389 18.3003C129.6 18.3003 130.29 19.2053 130.29 20.7531C130.29 22.3074 129.6 23.2124 128.389 23.2124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.58 24.3273H134.98V20.1497C134.98 19.0348 135.637 18.3397 136.672 18.3397C137.707 18.3397 138.201 18.9102 138.201 20.0579V24.3273H139.601V19.7038C139.601 18.0052 138.729 17.0477 137.147 17.0477C136.08 17.0477 135.377 17.5265 135.032 18.32H134.928V17.1854H133.58V24.3273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.045 15.4082V17.2182H144.919V18.4052H146.045V22.4385C146.045 23.8158 146.664 24.3666 148.219 24.3666C148.493 24.3666 148.753 24.3339 148.981 24.2945V23.1206C148.786 23.1403 148.662 23.1534 148.447 23.1534C147.751 23.1534 147.445 22.8255 147.445 22.0778V18.4052H148.981V17.2182H147.445V15.4082H146.045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.859 24.3273H152.258V20.1563C152.258 19.0742 152.896 18.3462 154.042 18.3462C155.031 18.3462 155.558 18.9233 155.558 20.0645V24.3273H156.958V19.7169C156.958 18.0183 156.027 17.0543 154.517 17.0543C153.45 17.0543 152.701 17.533 152.356 18.3331H152.245V14.3982H150.859V24.3273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.006 18.2479C163.04 18.2479 163.717 18.9758 163.75 20.0973H160.17C160.248 18.9824 160.971 18.2479 162.006 18.2479ZM163.743 22.3992C163.483 22.9566 162.904 23.2649 162.058 23.2649C160.938 23.2649 160.216 22.4713 160.17 21.2187V21.14H165.175V20.6482C165.175 18.4052 163.984 17.0477 162.012 17.0477C160.014 17.0477 158.745 18.4971 158.745 20.7793C158.745 23.0616 159.988 24.465 162.019 24.465C163.639 24.465 164.772 23.678 165.091 22.3992H163.743Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Apple logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6695 33.1799C39.7035 30.5237 41.1192 28.0103 43.365 26.6191C41.9482 24.5802 39.5751 23.2875 37.1062 23.2097C34.4729 22.9311 31.92 24.7974 30.5781 24.7974C29.2102 24.7974 27.1441 23.2373 24.9193 23.2834C22.0194 23.3778 19.3159 25.0392 17.905 27.5938C14.8722 32.8848 17.1344 40.6608 20.0396 44.9376C21.4932 47.0318 23.1919 49.3711 25.4147 49.2882C27.5899 49.1973 28.4022 47.8906 31.0278 47.8906C33.629 47.8906 34.3912 49.2882 36.6591 49.2354C38.9932 49.1973 40.4637 47.1319 41.8662 45.0178C42.9106 43.5256 43.7142 41.8764 44.2474 40.1312C41.5045 38.9623 39.6727 36.1808 39.6695 33.1799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3858 20.397C36.6584 18.8576 37.2854 16.879 37.1336 14.8813C35.1893 15.0871 33.3933 16.0234 32.1035 17.5038C30.8423 18.9501 30.1859 20.8939 30.31 22.8152C32.255 22.8354 34.167 21.9245 35.3858 20.397Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_2",
    x: -426,
    y: -74,
    width: 950,
    height: 220,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_2",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreBadge);
export default __webpack_public_path__ + "static/media/app-store-badge.93736ea223bd49bc397d90910801ddb9.svg";
export { ForwardRef as ReactComponent };